<template>
  <div class="flex flex-col gap-4">
    <!--    <DashboardCardTitle />-->
    <slot />
  </div>
</template>
